module.exports = __webpack_public_path__ + "dist/assets/img/fullstack.9652ad64.svg";